"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORE_TYPES = void 0;
var CORE_TYPES = {
    ApiAdapter: Symbol.for('ApiAdapter'),
    StorageService: Symbol.for('StorageService'),
    InitialiseUseCase: Symbol.for('InitialiseUseCase'),
    LogoutUseCase: Symbol.for('LogoutUseCase'),
    ForbiddenUseCase: Symbol.for('LogoutUseCase'),
    Route: Symbol.for('Route'),
    NavItem: Symbol.for('NavItem'),
};
exports.CORE_TYPES = CORE_TYPES;
//# sourceMappingURL=CoreTypes.js.map